import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { WebIntegrFuncionalidade } from '../models/webIntegrFuncionalidade.model';
import { Plano } from '../models/plano.model';
import { PlanoCategoria } from '../models/planoCategoria.model';
import { PlanoSituacao } from '../models/planoSituacao.model';
import { ViewModelFiltroWebBloqueioExcecao } from '../models/ViewModelFiltroWebBloqueioExcecao.model';
import { ViewModelProcessoWebBloqueioExcecao } from '../models/ViewModelProcessoWebBloqueioExcecao.model';
import { WebBloqueioExcecao } from '../models/webBloqueioExcecao.model';
import { environment } from 'environments/environment';
import { PlanoCategoriaSituacao } from '../models/planoCategoriaSituacao.model';

@Injectable({
    providedIn: 'root'
})
export class WebBloqueioExcecaoService {

    private baseUrl = `${environment.TrustCRMApiHost}api/WebBloqueioExcecao`;

    constructor(private http: HttpClient) { }

    retornaListaComboFuncionalidades(): Observable<WebIntegrFuncionalidade[]> {
        return this.http.get<WebIntegrFuncionalidade[]>(
            `${this.baseUrl}/retornaListaComboFuncionalidades`
        );
    }

    retornaListaComboPlanos(): Observable<Plano[]> {
        return this.http.get<Plano[]>(
            `${this.baseUrl}/retornaListaComboPlanos`
        );
    }

    retornaListaComboCategorias(): Observable<PlanoCategoria[]> {
        return this.http.get<PlanoCategoria[]>(
            `${this.baseUrl}/retornaListaComboCategorias`
        );
    }

    retornaListaComboSituacao(): Observable<PlanoSituacao[]> {
        return this.http.get<PlanoSituacao[]>(
            `${this.baseUrl}/retornaListaComboSituacao`
        );
    }
    retornaListaComboSituacaoPorCategoria(idCategoria: number): Observable<PlanoCategoriaSituacao[]> {
        return this.http.get<PlanoCategoriaSituacao[]>(
            `${this.baseUrl}/retornaListaComboSituacaoPorCategoria?idCategoria=${idCategoria}`
        );
    }

    postFiltroBloqueioExcecao(
        filtro: ViewModelFiltroWebBloqueioExcecao
    ): Observable<ViewModelProcessoWebBloqueioExcecao[]> {
        return this.http.post<ViewModelProcessoWebBloqueioExcecao[]>(
            `${this.baseUrl}/PostFiltroBloqueioExcecao`,
            filtro
        );
    }

    criarBloqueioExcecao(
        bloqueio: WebBloqueioExcecao
    ): Observable<WebBloqueioExcecao> {
        return this.http.post<WebBloqueioExcecao>(
            `${this.baseUrl}/CriarBloqueioExcecao`,
            bloqueio
        );
    }

    excluir(idSeq: number) {
        return this.http.post<any>(
            `${this.baseUrl}/DeleteById?id=${idSeq}`,
            ''
        );
    }
    editar(webBloqueioExcecao: WebBloqueioExcecao): Observable<WebBloqueioExcecao[]> {
        return this.http.post<WebBloqueioExcecao[]>(
            `${environment.TrustCRMApiHost}api/WebBloqueioExcecao/PutBloqueioExcecao`,
            webBloqueioExcecao
        );
    }

}